<template>
  <BaseTable
      :title="$t('machine')"
      :subtractHeight="subtractHeight"
      :height="height - 200"
      dto-model="MachineListQueryDTO"
      dto-save-list-model="MachineSaveListCommandDTO"
      store-name="MachineTable"
      new-item-component="MachineItem"
      new-item-pass="/Product/Machine/MachineItem"
      :lang-dictionary="function(text) {return $t(text)}"
      hide-default-footer
      fixed-header
  >
    <template v-slot:item.name="{ item }">
      <router-link :to="{name:'MachineItem', params: { itemUid: item.uid}}">
        <span v-if="item.name">{{ item.name }}</span>
        <span v-else>****</span>
      </router-link>
    </template>
    <template v-slot:item.group="{ item }">
      {{ $t('groups.' + item.group)}}
    </template>
    <template v-slot:item.task_types="{ item }">
      <v-chip small v-for="task in item.task_types" :key="task.name" :color="task.color">
        {{ task.name }}
      </v-chip>
      <span v-if="item.task_types.length === 0"> </span>
    </template>
  </BaseTable>
</template>

<script>

import BaseTable from "@/components/Base/BaseTable";

export default {
  name: 'MachineTable',
  props: {
    subtractHeight: {type: [Number], default: 80},
    height: {type: [Number], default: window.innerHeight},
  },

  components: {
    BaseTable,
  },

  computed: {},

  methods: {},

  async mounted() {
    // console.log('mounted')
  },

  data() {
    return {}
  }
}
</script>

<style>
.row_even {
}
</style>

<i18n src=".\locales.json">
</i18n>
